import React, { useEffect, useState } from "react";
import { api } from "../api/client";
import TabUser from "../components/admin/TabUser";
import TabCars from "../components/admin/TabCars";
import TabStops from "../components/admin/TabStops";
import TabPayments from "../components/admin/TabPayments";
import TabScheduling from "../components/admin/TabScheduling";
import TabTrips from "../components/admin/TabTrips";
import TabAllSchedules from "../components/admin/TabAllSchedules";
import TabAnnouncements from "../components/admin/TabAnnouncements";

export const GENDER_BG_COLORS = {
  male: "#c8fbfeff",
  female: "#f8d6fdff",
};

const TABS = [
  { key: "users", label: "Users" },
  { key: "cars", label: "Vehicles" },
  { key: "stops", label: "Stops" },
  { key: "payments", label: "Payments" },
  { key: "scheduling", label: "Find Schedule" },
  { key: "trips", label: "Trips" },
  { key: "all-schedules", label: "All Schedules" },
  { key: "announcements", label: "Announcements" },
];

export const timePattern = "^([01]?\\d|2[0-3]):([0-5]\\d)$";
export const timeRegex = /^([01]?\d|2[0-3]):([0-5]\d)$/;

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState(() => {
    const stored = localStorage.getItem("adminActiveTab");
    return stored || "users";
  });

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    localStorage.setItem("adminActiveTab", tabKey);
  };

  return (
    <div>
      <nav className="admin-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={`tab-btn${activeTab === tab.key ? " active" : ""}`}
            onClick={() => {
              handleTabChange(tab.key);
            }}
          >
            {tab.label}
          </button>
        ))}
      </nav>
      <div className="tab-content">
        {activeTab === "users" && <TabUser />}
        {activeTab === "cars" && <TabCars />}
        {activeTab === "stops" && <TabStops />}
        {activeTab === "payments" && <TabPayments />}
        {activeTab === "scheduling" && <TabScheduling />}
        {activeTab === "trips" && <TabTrips />}
        {activeTab === "all-schedules" && <TabAllSchedules />}
        {activeTab === "announcements" && <TabAnnouncements />}
      </div>
    </div>
  );
}
